<script>
import {mapGetters, mapActions} from 'vuex'
import userActions from '@/mixins/actionsMixin'

export default {
	mixins: [userActions],
	components: {
		SvgIcon: () => import('@/components/SvgIcon'),
		IndicationsView: () => import('@/components/evaluations/IndicationsView.vue'),
		QuizView: () => import('@/components/evaluations/QuizView.vue'),
		QuizEnd: () => import('@/components/evaluations/QuizEnd.vue')
	},

	data() {
		return {
			running: false,
			queueQuestions: [],
			historyQuestions: [],
			rescueQuestion: null,
			skipQuestion: null,
			pointsQuestion: 13/13,
			comodin50: true,
			comodinRescue: true,
			prevQuestion: null,
			completed: false,

			json_fields: {
				'_': 'pregunta',
				'__': 'respuesta',
			},
			json_meta: [
				[
					{
						'key': 'charset',
						'value': 'utf-8'
					}
				]
			],
		}
	},

	computed: {
		question() {
			return this.queueQuestions[Math.floor(Math.random()*this.queueQuestions.length)]
		},
		activity() {
			let activity = this.progressById(Number(this.$route.params.activity))
			if(!activity) {
				activity =  this.activityById(Number(this.$route.params.activity))
			}
			return activity
		},
		evaluation() {
			return this.evaluationByActivity(Number(this.$route.params.activity))
		},

		evaluationIndex() {
			return this._evaluationIndex(Number(this.$route.params.activity))
		},

		evaluationTries() {
			return this.getEvaluationTries(Number(this.$route.params.activity))
		},

		canTakeEvaluation() {
			return this.checkCanTakeEvaluation(Number(this.$route.params.activity))
		},
		assertAnswers() {
			return this.historyQuestions.filter(q => q.assert)
		},
		...mapGetters({
			activityById: 'activities/byId',
			progressById: 'auth/progressById',
			evaluationByActivity: 'evaluations/evaluationByActivity',
			_evaluationIndex: 'evaluations/evaluationIndex',
			userId: 'auth/userId',
			getEvaluationTries: 'auth/evaluationTries',
			checkCanTakeEvaluation: 'auth/canTakeEvaluation',
			activityViewed: 'auth/activityViewed',
			activityCompleted: 'auth/activityCompleted',
			userName: 'auth/userName',
			userCode: 'auth/userCode'
		})
	},

	watch: {
		'evaluation.questions': {
			handler(nVal) {
				if(!nVal.length) {
					return
				}
				let questions = nVal.map(v => Object.assign({}, v)).sort(function(){return 0.5 - Math.random()})
				this.queueQuestions = questions.slice(0, 10)
				this.rescueQuestion = questions[10]
				// this.$set(this, 'rescueQuestion', questions[10])
			},
			deep: true,
			immediate: true
		}
	},

	methods: {
		excelData() {
			let vm = this
			let activity = vm.activity
			let results = activity.evaluation.results
			let data  = [
				{
					pregunta: `Resultados ${activity.title}`,
					respuesta: `Participante: ${vm.userName} Código: ${vm.userCode}`,
				},
				{
					pregunta: '',
					respuesta: '',
				},
				{
					pregunta: `Puntos Obtenidos: ${activity.evaluationPoints}`,
					respuesta: '',
				},
				{
					pregunta: `Intentos: ${activity.evaluationTries}`,
					respuesta: '',
				},
				{
					pregunta: '',
					respuesta: '',
				},
				
				
			]

			results.forEach((r, index) => {
				let respuesta = r.options.find(o => o.id == r.resolve)
				data.push({
					pregunta: `${index + 1} ${r.title}`,
					respuesta: `${r.assert ? '✅' : '❌'} ${respuesta.text}`
				})
			});
			this.downloadExcel({
				name: `${this.userName}_${this.userCode}_${this.activity.title}`,
				fields: [{sheetid:'One',header:false}],
				data: [data]
			})
			// return data
		},
		handlerStart() {
			this.running = true
			this.curentQuestion = 1
			let questions = this.evaluation.questions.map(v => Object.assign({}, v)).sort(function(){return 0.5 - Math.random()})
			this.queueQuestions = questions.slice(0, questions.length)
			this.historyQuestions = []

		},

		onNextQuestion(data) {
			this.validateAnswer(data)
		},

		onPrevQuestion(data) {
			this.prevQuestion = this.historyQuestions[this.historyQuestions.length - data]
		},

		validateAnswer(data) {
			let questionIndex = this.queueQuestions.findIndex(q => q.id === data.id)
			let question = Object.assign({}, this.queueQuestions[questionIndex])
			question.assert = false
			if(question.answers.includes(data.answer)) {
				question.assert = true
			}

			question.resolve = data.answer

			this.queueQuestions.splice(questionIndex, 1)
			this.historyQuestions.push(question)
			if(!this.queueQuestions.length) {
				this.completedQuiz()
			}
		},

		async completedQuiz() {
			this.completed = true
			this.running = false
			let activity = {...this.activity}
			let points = (this.assertAnswers.length * this.pointsQuestion)
			activity.evaluation = Object.assign({...this.evaluation}, {results: [...this.historyQuestions]})
			activity.completed = true,
			activity.viewed = true
			activity.evaluationTries = 1
			activity.evaluationPoints = points

			// window._SCORM.set(`cmi.objectives.${this.evaluationIndex}.score.raw`, points)
			// window._SCORM.set(`cmi.objectives.${this.evaluationIndex}.status`, activity.completed ? 'passed' : 'failed')
			// window._SCORM.save()
			
			// if(!activity.completed && activity.evaluationTries == 2) {
			// 	this.resetActivity()
			// }
			await this.saveProgress(Object.assign({...activity}, {userId: this.userId}))
		},

		resetActivity() {
			let activity = this.activityById(Number(this.$route.params.activity))
			let module = this.$route.params.module

			let name = this.userId + activity.activityId + activity.url
			delete localStorage[name]

		},

		onUseComodin50() {
			this.comodin50 = false
		},

		onUseComodinRescue(questionId) {
			this.comodinRescue = false
			let questions = this.queueQuestions.map(q => Object.assign({}, q))
			let questionIndex = questions.findIndex(q => q.id === questionId)
			let question = questions[questionIndex]
			this.$set(this, 'skipQuestion', question)
			this.queueQuestions.splice(questionIndex, 1)
			this.queueQuestions.push(Object.assign({}, this.rescueQuestion))
		},

		...mapActions({
			saveProgress: 'auth/saveUserProgress'
		})
	},

	mounted() {
		this.saveTimeUserBack()
	}
}
</script>
<template>
	<div  class="evaluation">
		<QuizView v-if="running"
		:key="`quiz_quiestion_view-${question.id}`" 
		:comodines="false"
		:comodin50="comodin50" 
		:comodin-rescue="comodinRescue" 
		:score="assertAnswers.length * pointsQuestion" 
		:question="prevQuestion || question"
		:count="queueQuestions.length + historyQuestions.length"
		:number="historyQuestions.length + 1"
		:timer-show="false"
		:random="false"
		@useComodin50="onUseComodin50"
		@useComodinRescue="onUseComodinRescue"
		@prevQuestion="onPrevQuestion"
		@nextQuestion="onNextQuestion"/>
		<div class="wrapper" v-else-if="activity.completed">
			<div class="indications">
				<h2 class="title"><span>Evaluación completada.</span></h2>
				<div class="description">
					Alcanzaste {{activity.evaluationPoints}} puntos en esta evaluación.
					<p class="small m-0"> Descarga y envía tus resultados al correo de tu asesor facilitador</p>
				</div>
				<button @click="excelData" class="btn btn-bbva mt-5">
					<span>Descargar Resultados <i class="fa fa-download" aria-hidden="true"></i></span> 
				</button>
				<button @click="goNext(activity.activityId)" class="btn btn-bbva mt-5 mx-2">
					<span>Siguiente actividad</span>
				</button>
			

			</div>
			<img class="indications__img" style="width: 60%" src="../assets/svg/completed-16.svg" alt="">
			<!-- <button @click="goNext($route.params.activity)" class="btn btn-primary btn-rounded quiz__next ml-5">
				<span>Siguiente actividad</span>
			</button> -->
		</div>
		<div class="wrapper" v-else>
			<div class="indications">
				<h2 class="title"><span>{{activity.title}}</span></h2>
				<div class="description" v-html="evaluation.description"></div>
				<div><button class="btn btn-bbva" @click="handlerStart">Iniciar</button></div>
			</div>
			<img class="indications__img" src="../assets/svg/avatar-36.svg" alt="">
			<!-- <img @click="$emit('start')" class="avatar" src="../assets/svg/avatar-36.svg" alt="">
			<button @click="handlerStart" class="btn btn-primary btn-rounded quiz__next ml-5">
				<span>INICIAR</span>
			</button> -->
		</div>
		
		<!-- <pre>{{question}}</pre> -->
		<footer class="evaluation__footer">
			<img src="@/assets/img/logo_blanco_tag.png" alt="">
		</footer>
	</div>
</template>
<style  lang="scss" scoped>
.evaluation{
	margin-left: 90px;
	height: 100%;
	overflow: auto;
	position: relative;
	.wrapper{
		min-height: calc(100% - 60px);
	}
	footer{
		width: 100%;
		overflow: hidden;
		height: 60px;
		background-color: #00143F;
		padding: 0.5rem;
		text-align: right;
		position: sticky;
		bottom: 0;
		left: 0;
		// width: 100%;
		img{
			height: 100%;
		}
	}
}
.indications{
	max-width: 70%;
	padding: 3rem;
	color: #fff;
	&__img{
		width: 50%;
		position: absolute;
		right: 0;
		bottom: 0;
		display: block;
		margin-left: auto;
		margin-top: -15%;
		// right: 0;
	}
}
.title{
	font-size: 3em;
	font-weight: 700;
	span{
		font-weight: 300;
	}
}
.description{
	font-size: 1.5em;
}
.wrapper{
	background-image: url('../assets/img/evaluations/bg_03.png');
	background-attachment: fixed;
	background-size: cover;
	position: relative;
	padding: 1em;
}

.avatar{
	max-height: 80vh;
	position: absolute;
	bottom: 0;
}
.quiz__next{
	position: absolute;
	bottom: 5%;
	left: 50%;
	transform: translateX(-50%);
}
.quiz{
	&__nav{
		border: 0;
		padding: 0;
		height: 50px;
		border-radius: 50px;
		white-space: nowrap;
		padding: 0 1rem;
		text-transform: uppercase;
		font-weight: 700;
		position: absolute;
		bottom: 5%;
		left: 50%;
		transform: translateX(-50%);
		background-color: #F8CD51;
		cursor: pointer;
		color: #000;
		text-decoration: none !important;
		outline: none !important;
		span{
			line-height: 3em;
		}
		img{
			width: 40px;
		}
		&:hover{
			background-color: darken($color: #F8CD51, $amount: 5);
		}
	}
}
</style>